export default "/images/vendor/flag-icon-css/flags/4x3/to.svg?65dda6ec6f9719bbd78463630e8470b6";